/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewStep = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The BusinessReviewStep model module.
   * @module model/BusinessReviewStep
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>BusinessReviewStep</code>.
   * @alias module:model/BusinessReviewStep
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>BusinessReviewStep</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BusinessReviewStep} obj Optional instance to populate.
   * @return {module:model/BusinessReviewStep} The populated <code>BusinessReviewStep</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TemplateID')) {
        obj['TemplateID'] = ApiClient.convertToType(data['TemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('MaterialText')) {
        obj['MaterialText'] = ApiClient.convertToType(data['MaterialText'], 'String');
      }
      if (data.hasOwnProperty('TaskText')) {
        obj['TaskText'] = ApiClient.convertToType(data['TaskText'], 'String');
      }
      if (data.hasOwnProperty('TargetPageURI')) {
        obj['TargetPageURI'] = ApiClient.convertToType(data['TargetPageURI'], 'String');
      }
      if (data.hasOwnProperty('TargetElementSelector')) {
        obj['TargetElementSelector'] = ApiClient.convertToType(data['TargetElementSelector'], 'String');
      }
      if (data.hasOwnProperty('TargetElementSideID')) {
        obj['TargetElementSideID'] = ApiClient.convertToType(data['TargetElementSideID'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TemplateID
   * @default 0
   */
  exports.prototype['TemplateID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} MaterialText
   * @default ''
   */
  exports.prototype['MaterialText'] = '';
  /**
   * @member {String} TaskText
   * @default ''
   */
  exports.prototype['TaskText'] = '';
  /**
   * @member {String} TargetPageURI
   * @default ''
   */
  exports.prototype['TargetPageURI'] = '';
  /**
   * @member {String} TargetElementSelector
   * @default ''
   */
  exports.prototype['TargetElementSelector'] = '';
  /**
   * @member {Integer} TargetElementSideID
   */
  exports.prototype['TargetElementSideID'] = undefined;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


